/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-27 19:23:08
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-05 20:11:37
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 团长列表
export const talentList = params => {
	return request({
		url: '/api/talent/list',
		data: params,
		method: AjaxMethod.post,
	});
};
export const loopSyncStatus = data => {
	return request({
		url: '/api/talent/sync-status',
		data,
		method: AjaxMethod.post,
		// notOrigin: true,
	});
};
// 编辑达人信息
export const editTalent = params => {
	return request({
		url: '/api/talent/edit-talent',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取编辑达人信息
export const getPartnerAnchorInfo = params => {
	return request({
		url: '/api/partner-anchor/partner-anchor-info',
		params,
		method: AjaxMethod.get,
	});
};

// 商品类目
export const getCateList = params => {
	return request({
		url: '/api/product-info/cate-list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 达人公海
export const getTalentSeaList = data => {
	return request({
		url: '/api/talent/talent-sea',
		data,
		method: AjaxMethod.post,
	});
};

// 认领达人
export const claimTalent = data => {
	return request({
		url: '/api/talent/claim',
		data,
		method: AjaxMethod.post,
	});
};

//保存抖音联系方式
export const myTalentDetailSyncJxContact = data => {
	return request({
		url: '/api/team-anchor/sync-jx-contact',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//保存快手联系方式
export const myTalentDetailSyncKsContact = data => {
	return request({
		url: '/api/ks-anchor/sync-ks-contact',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 达人管理
export const getTalentManageList = data => {
	return request({
		url: '/api/talent/manage',
		data,
		method: AjaxMethod.post,
	});
};

// 建联
export const talentContact = data => {
	return request({
		url: '/api/talent/contact',
		data,
		method: AjaxMethod.post,
	});
};

// 添加联系人
export const addContactPerson = data => {
	return request({
		url: '/api/talent/add-contact',
		data,
		method: AjaxMethod.post,
	});
};

// 绑定已有联系人
export const bindContact = data => {
	return request({
		url: '/api/talent/bind-contact',
		data,
		method: AjaxMethod.post,
	});
};

// 达人管理tab
export const getTalentManageTab = data => {
	return request({
		url: '/api/talent/manage-tab',
		data,
		method: AjaxMethod.post,
	});
};

// 联系人列表
export const getContactList = data => {
	return request({
		url: '/api/contact/list',
		data,
		method: AjaxMethod.post,
	});
};

// 线索来源
export const getSourceList = params => {
	return request({
		url: '/api/talent/from-type',
		params,
		method: AjaxMethod.get,
	});
};

// 当前团长关联的所有达人
export const getPartnerAnchorList = data => {
	return request({
		url: '/api/partner/anchor-list',
		data,
		method: AjaxMethod.post,
	});
};

// 重点关注/取消关注
export const setTalentFocus = data => {
	return request({
		url: '/api/talent/focus',
		data,
		method: AjaxMethod.post,
	});
};

// 删除联系人
export const delContact = data => {
	return request({
		url: '/api/contact/del',
		data,
		method: AjaxMethod.post,
	});
};

// 联系人选项
export const getTalentContactList = data => {
	return request({
		url: '/api/talent/contact-list',
		data,
		method: AjaxMethod.post,
	});
};

// 团长列表
export const getPartnerList = params => {
	return request({
		// url: '/api/partner/list',
		url: '/api/partner-anchor/relate-user-list',
		params,
		method: AjaxMethod.get,
	});
};

// 分配达人
export const allotTalent = data => {
	return request({
		url: '/api/talent/allot',
		data,
		method: AjaxMethod.post,
	});
};

// 重新分配达人
export const againAllot = (data, notOrigin = true) => {
	return request({
		url: '/api/team-sea/sea-allot',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 设置合作达人为有效状态
export const effectTalent = data => {
	return request({
		url: '/api/talent/effect',
		data,
		method: AjaxMethod.post,
	});
};

// 设置合作达人为失效状态
export const unEffectTalent = data => {
	return request({
		url: '/api/talent/un-effect',
		data,
		method: AjaxMethod.post,
	});
};

// 添加抖音达人
export const addAnchor = data => {
	return request({
		url: '/api/talent/add-anchor',
		data,
		method: AjaxMethod.post,
	});
};

// 合作数据
export const getPartnerData = data => {
	return request({
		url: '/api/talent-data/partner-data',
		data,
		method: AjaxMethod.post,
	});
};

// 成交数据
export const getMakeData = data => {
	return request({
		url: '/api/talent-data/finish-data',
		data,
		method: AjaxMethod.post,
	});
};

// 待办数据
export const getWaitData = data => {
	return request({
		url: '/api/talent-data/wait-data',
		data,
		method: AjaxMethod.post,
	});
};

// 获取团长关联达人信息（达人详情）
export const getAnchorDetail = data => {
	return request({
		url: '/api/partner/anchor-info',
		data,
		method: AjaxMethod.post,
	});
};

// 跟进记录
export const getFollowList = data => {
	return request({
		url: '/api/talent-data/follow-data',
		data,
		method: AjaxMethod.post,
	});
};

// 当前团长关联的达人联系人列表（达人详情）
export const getAnchorContactList = data => {
	return request({
		url: '/api/contact/anchor-contact',
		data,
		method: AjaxMethod.post,
	});
};

// 达人批量添加
export const batchAddTalent = data => {
	return request({
		url: '/api/talent/batch-add',
		data,
		method: AjaxMethod.post,
	});
};

// 导出失败
export const exportAddFail = (params, notOrigin = true) => {
	return request({
		url: '/api/talent/export-add-fail',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 业绩数据面板
export const getResultsInfo = data => {
	return request({
		url: '/api/stat/achievement',
		data,
		method: AjaxMethod.post,
	});
};

// 员工业绩列表
export const getEmployeesList = data => {
	return request({
		url: '/api/stat/list-talent-achievement',
		data,
		method: AjaxMethod.post,
	});
};

//修改联系人信息
export const editContact = data => {
	return request({
		url: '/api/contact/edit',
		data,
		method: AjaxMethod.post,
	});
};

//是否添加微信
export const addwxfriend = data => {
	return request({
		url: '/api/contact/add-wx-friend',
		data,
		method: AjaxMethod.post,
	});
};

// 直播数据概览
export const getLiveData = data => {
	return request({
		url: '/api/talent-data/live-data',
		data,
		method: AjaxMethod.post,
	});
};

// 直播商品数据
export const getLiveProductList = data => {
	return request({
		url: '/api/talent-data/live-product',
		data,
		method: AjaxMethod.post,
	});
};

// 直播场次
export const getLiveBroadcast = data => {
	return request({
		url: '/api/talent-data/live-broadcast',
		data,
		method: AjaxMethod.post,
	});
};

// 修改备注
export const editEemark = data => {
	return request({
		url: '/api/talent/edit-remark',
		data,
		method: AjaxMethod.post,
	});
};

// 获取待订正数据
export const getWaitFix = data => {
	return request({
		url: '/api/partner-anchor/get-wait-fix',
		data,
		method: AjaxMethod.post,
	});
};

// 设置是否允许多个达人商务跟进同个达人-抖音
export const addFixTask = data => {
	return request({
		url: '/api/partner-anchor/add-fix-task',
		data,
		method: AjaxMethod.post,
	});
};

// 设置是否允许多个达人商务跟进同个达人-快手
export const addKsFixTask = data => {
	return request({
		url: '/api/partner-anchor/add-ks-fix-task',
		data,
		method: AjaxMethod.post,
	});
};
// 设置是否考核达人运营对达人的跟进记录次数
export const setCheckFollow = (data, notOrigin = true) => {
	return request({
		url: '/api/team-conf/set-check-follow',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 设置达人自动流转规则配置
export const drFlow = (data, notOrigin = true) => {
	return request({
		url: '/api/team-conf/circulation-config',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 设置业绩归属规则配置
export const Performance = (data, notOrigin = true) => {
	return request({
		url: '/api/team-conf/attribution-config',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 获取配置-是否考核达人运营对达人的跟进记录次数
export const getCheckFollow = data => {
	return request({
		url: '/api/team-conf/get-check-follow',
		data,
		method: AjaxMethod.post,
	});
};
// 获取团队跟进方式
export const getPartnerAnchor = data => {
	return request({
		url: '/api/team-conf/get-partner-to-anchor',
		data,
		method: AjaxMethod.post,
	});
};

// 获取达人视频数据
export const getVideoData = data => {
	return request({
		url: '/api/talent-data/video-data',
		data,
		method: AjaxMethod.post,
	});
};

// 员工业绩列表导出
export const employeesExport = (params, notOrigin = true) => {
	return request({
		url: '/api/stat/export-talent-achievement',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 达人crm删除
export const delAnchor = data => {
	return request({
		url: '/api/talent/del-anchor',
		data,
		method: AjaxMethod.post,
	});
};

// 达人导入记录
export const getTalentExportList = data => {
	return request({
		url: '/api/talent/export-add-record',
		data,
		method: AjaxMethod.post,
	});
};

// 现跟进人达人跟进数据
export const anchorInfo = data => {
	return request({
		url: '/api/talent-data/anchor-partner-info',
		data,
		method: AjaxMethod.post,
	});
};

// 达人商务列表
export const partnerList = data => {
	return request({
		url: '/api/common/user-list',
		data,
		method: AjaxMethod.post,
	});
};

// 团队公海
export const getTeamSeaList = data => {
	return request({
		url: '/api/team-sea/anchor-list',
		data,
		method: AjaxMethod.post,
	});
};

// 团队公海分配（重新分配）达人
export const teamSeaAllot = data => {
	return request({
		url: '/api/team-sea/sea-allot',
		data,
		method: AjaxMethod.post,
	});
};

// 团队公海认领达人
export const teamSeaClaim = data => {
	return request({
		url: '/api/team-sea/sea-claim',
		data,
		method: AjaxMethod.post,
	});
};

// 达人当前跟进人列表
export const getTalentPartnerList = data => {
	return request({
		url: '/api/talent-data/anchor-partner-list',
		data,
		method: AjaxMethod.post,
	});
};

// 更新地址
export const updDeliveryInfo = data => {
	return request({
		url: 'api/contact/upd-delivery-info',
		data,
		method: AjaxMethod.post,
	});
};

// 快手核心数据
export const getKSCronData = params => {
	return request({
		url: '/api/talent-data/ks-cron-data',
		params,
		method: AjaxMethod.get,
	});
};

// 快手粉丝特征
export const getKSFans = params => {
	return request({
		url: '/api/talent-data/ks-fans',
		params,
		method: AjaxMethod.get,
	});
};

// 快手带货数据
export const getKSLiveFeature = params => {
	return request({
		url: '/api/talent-data/ks-live-feature',
		params,
		method: AjaxMethod.get,
	});
};

// 同步达人基础信息
export const syncAnchorBase = data => {
	return request({
		url: '/api/talent/sync-anchor-base',
		data,
		method: AjaxMethod.post,
	});
};

// 同步达人基础信息视频号
export const syncSphAnchorBase = data => {
	return request({
		url: '/api/talent/sync-sph-base',
		data,
		method: AjaxMethod.post,
	});
};

// 团队公海导出
export const teamSeaExport = data => {
	return request({
		url: '/api/team-sea/export',
		data,
		method: AjaxMethod.post,
	});
};

// 我的达人及重点关注达人导出
export const talentExport = data => {
	return request({
		url: '/api/talent/export',
		data,
		method: AjaxMethod.post,
	});
};

// ks编辑主页链接
export const addKsLink = data => {
	return request({
		url: '/api/talent/add-ks-link',
		data,
		method: AjaxMethod.post,
	});
};

// 员工业绩列表(招商运营)
export const getZsEmployeesList = data => {
	return request({
		url: '/api/stat/list-bd-achievement',
		data,
		method: AjaxMethod.post,
	});
};

// 员工业绩列表导出(招商运营)
export const exportZsEmployeesList = (params, notOrigin = true) => {
	return request({
		url: '/api/stat/export-bd-achievement',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//批量导入达人
export const importTalents = (data, notOrigin = true) => {
	return request({
		url: '/api/team-anchor/batch-allot',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};
//操作列表获取
export const operaterList = data => {
	return request({
		url: '/api/team-anchor/batch-allot-list',
		data,
		method: AjaxMethod.post,
	});
};
//确认撤销
export const confirmCancle = (data, notOrigin = true) => {
	return request({
		url: '/api/team-anchor/cancel-batch-allot',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};
//获取失败列表数据
export const getReasonList = (data, notOrigin = true) => {
	return request({
		url: '/api/team-anchor/allot-fail-list',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};
//获取当前商务跟进且其他商务也在跟进的达人
export const getTanlentPartner = (data, notOrigin = true) => {
	return request({
		url: '/api/partner-anchor/other-partner-anchor',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};

//线索公海下拉筛选接口
export const clueSelectList = data => {
	return request({
		url: '/api/talent/search-items',
		data,
		method: AjaxMethod.post,
	});
};
// 批量检查是否多商务跟进
export const checkMultiFollow = params => {
	return request({
		url: '/saas-api/anchor/partner/team-anchor/check-multi-follow',
		data: params,
		method: AjaxMethod.post,
	});
};

// 批量修改合作进度-我的达人
export const partnerAnchorBatchModify = data => {
	return request({
		url: '/saas-api/anchor/partner/partner-anchor/batch-modify',
		data,
		method: AjaxMethod.post,
	});
};

// 批量修改合作进度-团队公海
export const teamAnchorBatchModify = data => {
	return request({
		url: '/saas-api/anchor/partner/team-anchor/batch-modify',
		data,
		method: AjaxMethod.post,
	});
};

//修改合作进度-我的达人
export const partnerModifyCooperate = data => {
	return request({
		url: '/saas-api/anchor/partner/partner-anchor/modify-cooperate',
		data,
		method: AjaxMethod.post,
	});
};

//修改合作进度-团队公海
export const teamModifyCooperate = data => {
	return request({
		url: '/saas-api/anchor/partner/team-anchor/modify-cooperate',
		data,
		method: AjaxMethod.post,
	});
};
// 多个达人新增标签
export const setAnchorTag = data => {
	return request({
		url: '/api/tags/bulk-set-anchor-tag',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 一个达人新增标签
export const setAnchorTags = data => {
	return request({
		url: '/api/tags/set-anchor-tags',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 根据达人简介获取达人联系方式
export const descContact = data => {
	return request({
		url: '/api/talent/desc-contact',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

export const getMyTalentDetailCheckExist = data => {
	return request({
		url: '/api/contact/check-exist',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取库存精选联盟达人联系方式
export const getJxContactInfo = data => {
	return request({
		url: '/api/talent/jx-contact-info',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 快手获取达人库联系方式
export const getKsContactInfo = data => {
	return request({
		url: '/api/ks-anchor/ks-contact-info',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

export const queryUsing = data => {
	return request({
		url: '/admin-api/micro-admin-api/tenant-file-manage/query-using',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 插件统计下载次数
export const talentReportLog = params => {
	return request({
		url: '/api/talent/report-log',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//获取精选联盟店铺信息
export const getAllianceShopList = data => {
	return request({
		url: '/api/jx-shop/shop-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//快手店铺列表
export const getKsShopList = data => {
	return request({
		url: '/api/ks-anchor/shop-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

export const getPlugVersionApi = data => {
	return request({
		url: '/api/plugin-anchor/using',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 新建达人时根据 名称进行检索
export const searchSpByName = data => {
	return request({
		url: '/api/talent/search-sph',
		data,
		method: AjaxMethod.post,
	});
};

// 视频号编辑达人
export const editSphAnchor = data => {
	return request({
		url: '/api/talent/edit-sph-anchor',
		data,
		method: AjaxMethod.post,
	});
};

// 近30天数据概览
export const talentSphOverview = data => {
	return request({
		url: '/api/talent-data/sph-overview',
		data,
		method: AjaxMethod.post,
	});
};

// 获取业绩归属规则 https://yangxuan.w.eolink.com/home/api-studio/inside/ZgDLyaed5c4a96becb7f00a8cce608c0832d57f7842505e/api/2642826/detail/54423027?spaceKey=yangxuan
export const getPartnerToAnchor = data => {
	return request({
		url: '/api/team-conf/get-partner-to-anchor',
		params: data,
		method: AjaxMethod.get,
	});
};

// 业绩归属规则设置 https://yangxuan.w.eolink.com/home/api-studio/inside/ZgDLyaed5c4a96becb7f00a8cce608c0832d57f7842505e/api/2642826/detail/54423028?spaceKey=yangxuan
export const setPartnerToAnchor = data => {
	return request({
		url: '/api/team-conf/set-anchor-config',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 根据昵称搜索昵称&视频号ID关联关系
export const sphIdSearchList = params => {
	return request({
		url: '/api/sph/search-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 获取达人橱窗授权信息 https://yangxuan.w.eolink.com/home/api-studio/inside/xdEADn8ec64dc2dbd8cca7a2cc275b2f8fbf39e0567e399/api/2999045/detail/54565378?spaceKey=yangxuan
export const getAnchorShowcase = data => {
	return request({
		url: '/domain-shop/rpc/cyt/sph/anchor/getWindowAuthInfo',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 校验是否团队公海已经添加
export const sphCheckAddVideo = data => {
	return request({
		url: '/api/sph/check-add-video',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 我的达人导入模板
export const partnerAnchorImportUrl = data => {
	return request({
		url: '/api/partner-anchor/import-url',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 我的达人导入模板
export const teamAnchorImportUrl = data => {
	return request({
		url: '/api/team-anchor/import-url',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 取消认领达人
export const cancelAnchorCancelOne = data => {
	return request({
		url: '/api/cancel-anchor/cancel-one',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 批量取消认领达人
export const cancelAnchorBatchCancel = data => {
	return request({
		url: '/api/cancel-anchor/batch-cancel',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 批量取消认领达人记录
export const cancelAnchorBatchCancelRecords = data => {
	return request({
		url: '/api/cancel-anchor/batch-records',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 批量加入黑名单
export const batchBlacklistAnchor = data => {
	return request({
		url: '/api/blacklist-anchor/batch-block',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 加入黑名单
export const blacklistAnchor = data => {
	return request({
		url: '/api/blacklist-anchor/block',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 黑名单列表
export const blacklist = data => {
	return request({
		url: '/api/blacklist-anchor/list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 黑名单导出
export const blacklistExport = data => {
	return request({
		url: '/api/blacklist-anchor/export',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 恢复黑名单
export const blacklistUnblock = data => {
	return request({
		url: '/api/blacklist-anchor/unblock',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 批量恢复黑名单
export const batchBlacklistUnblock = data => {
	return request({
		url: '/api/blacklist-anchor/batch-unblock',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
